module.exports = __webpack_public_path__ + "static/media/LV=.6fce4760.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/LV=.png
// module id = 4084
// module chunks = 0